import type { FaireProductEntity } from "../../entity_types/product";

export const p_nt6eu75g53: FaireProductEntity = {
  token: "p_nt6eu75g53",
  type: "product",
  name: "Southern Style Case- 24 cans",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/49cbd5dea9aa103439f112c4ce4d6c5e5d59435c80a9e6454013848fc2dae900.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c203aabba519427db770660ab1599a58da082f35a4ca7db6e5d3b42852564d38.jpeg",
    "https://cdn.faire.com/fastly/93e8d49822655e3a2c1fc74bd3ae6e45a71808226dc011011771dbc3787546f9.jpeg",
    "https://cdn.faire.com/fastly/74a0a931860b2e255073a1004f77ecb103e4749d10fcb2d39d5f4dc0e8894c02.jpeg"
  ],
  priceDollars: 2.75,
  description: "\nSouthern Style is our take on an Arnold Palmer. We swapped the tea for coffee and added bubbles to give you a delicious and fun way to enjoy these classic flavors.\n\nAt Comeback, we source high-quality ingredients to combine with our in-house roasted and flash-chilled coffee. Shaking up the typical flavors often combined with coffee, we rejoin coffee with its first home, fruit.\n",
  tags: [],
  msrpDollars: 5.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:06.982Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
